import { Field, useFormikContext } from 'formik'
import { FaCheck } from 'react-icons/fa'

export default function RadioButton({ className = '', group = false, error = '', onChange, version = 'default', ...props }) {
    const { setFieldValue } = useFormikContext()
    if (group) {
        return (
            <div>
                {props.label && (
                    <label className={`block mb-1 font-medium ${error ? 'text-danger' : 'text-black dark:text-white'}`}>
                        {props.label}
                    </label>
                )}
                <div className={className}>
                    {props.datas.map((data, key) => (
                        <RadioButton
                            key={key}
                            id={props.name + data.id}
                            name={props.name}
                            value={data.id}
                            checked={data.id.toString() === props.value.toString()}
                            label={data.label}
                            message={data.message ?? ''}
                            disabled={props.disabled ?? false}
                            onChange={onChange}
                        />
                    ))}
                </div>
                {error && <p className="text-sm text-danger">{error}</p>}
            </div>
        )
    }

    return (
        <div className={className}>
            <label
                htmlFor={props.id}
                className={`inline-flex items-center select-none ${props.disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
            >
                <div className="relative">
                    <Field
                        type="radio"
                        {...props}
                        className="sr-only"
                        onChange={e => {
                            setFieldValue(props.name, e.target.value)
                            onChange?.(e)
                        }}
                    />
                    {version === 'default' ? (
                        <div
                            className={`${props.label ? 'mr-2' : ''} flex h-5 w-5 items-center justify-center rounded-full border
                            ${props.checked ? '!border-4' : ''}
                            ${props.disabled ? 'bg-gray dark:bg-graydark' : 'border-primary dark:border-secondary'}`}
                        >
                            <span className={`h-2 w-2 rounded-full ${props.checked ? 'bg-white dark:bg-boxdark' : ''}`}></span>
                        </div>
                    ) : (
                        <div
                            className={`
                            ${props.label ? 'mr-2' : ''} flex h-7 w-7 items-center justify-center border
                            ${props.disabled ? 'bg-gray dark:bg-graydark' : 'border-primary dark:border-secondary'}
                            ${props.checked ? 'bg-primary dark:bg-secondary' : ''}
                        `}
                        >
                            {props.checked && <FaCheck className="w-5 h-5 text-white dark:text-boxdark" />}
                        </div>
                    )}
                </div>
                {props.label}
                {props.message && (
                    <>
                        <br />
                        {props.message}
                    </>
                )}
            </label>
        </div>
    )
}
